import { toast } from 'react-toastify';
import { usersApi } from 'entities/users';

const updateUsersExcelApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    updateUsersExcel: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        formData.append('country_id', data.country_id);
        formData.append('file', data.file);
        return {
          url: '/sales-point/admin/sales-point/admin/sales-points/download_users',
          method: 'PATCH',
          body: formData,
        };
      },
      invalidatesTags: (result, error) => {
        const error_message = (error as any)?.data.detail[0].msg;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно загрузили файл', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'Users' }];
      },
    }),
    confirmUpdateUsersDotsListExcel: builder.mutation({
      query: (data) => ({
        url: '/sales-point/admin/sales-point/admin/sales-points/update_users',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно обновили пользователей', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'Users' }];
      },
    }),
  }),
});

export const { useUpdateUsersExcelMutation, useConfirmUpdateUsersDotsListExcelMutation } = updateUsersExcelApi;
